function changeInventory(){
  const selectedVariant = document.querySelector('input[name="id[]"]').value;
  const inventoryElement = document.querySelector('.inventory-alerts p');
  const variant = themeObject.product.inventory.find(variant => variant.id == selectedVariant);
  const inventoryMessages = themeObject.product.inventoryMessages;
  const inventorySettings = themeObject.product.inventory.settings;
  
  if (variant) {
    let inventoryMessage = '';
    let inventoryClass = '';

    if (variant.continue === 'continue') {
      inventoryMessage = inventoryMessages.inStock;
      inventoryClass = 'in-stock';
    } else {
      if (variant.quantity > inventorySettings.lowStock) {
        inventoryMessage = inventoryMessages.inStock;
        inventoryClass = 'in-stock';
      } else if (variant.quantity > inventorySettings.veryLowStock) {
        inventoryMessage = inventoryMessages.lowStock.replace(/\d+/, variant.quantity);
        inventoryClass = 'low-stock';
      } else if (variant.quantity > 0) {
        if (variant.quantity === 1) {
          inventoryMessage = inventoryMessages.veryLowStockOne.replace(/\d+/, variant.quantity);
        } else {
          inventoryMessage = inventoryMessages.veryLowStock.replace(/\d+/, variant.quantity);
        }
        inventoryClass = 'very-low-stock';
      } else {
        inventoryMessage = inventoryMessages.outOfStock;
        inventoryClass = 'out-of-stock';
      }
    }

    inventoryElement.querySelector('span:last-child').innerHTML = inventoryMessage;
    inventoryElement.className = inventoryClass;
  }
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelector('variant-radios').addEventListener('change', function(){
    setTimeout(changeInventory, 1000);
  });
});
